export default "__VITE_ASSET__Chomo6oD__"